module.exports = __webpack_public_path__ + "static/img/8.1bfb1aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/8.png
// module id = cJp1
// module chunks = 0